import React, { useState } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // Corrected import
import html2canvas from 'html2canvas';

const ExportModal = ({ isOpen, onClose, data, chartRef }) => {
    const [email, setEmail] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);

    if (!isOpen) return null;

    const handleExportCSV = () => {
        const headers = Object.keys(data);
        const values = Object.values(data);
        const csvContent = "data:text/csv;charset=utf-8," + headers.join(",") + "\n" + values.join(",");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "farm_summary.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    const handleExportPDF = async () => {
        setIsGenerating(true);
        const pdf = new jsPDF();

        // Add Title
        pdf.setFontSize(18);
        pdf.text("Farm Dashboard Summary", 14, 22);

        // Add Date
        pdf.setFontSize(11);
        pdf.setTextColor(100);
        pdf.text(`Report generated on: ${new Date().toLocaleDateString()}`, 14, 29);

        // Create a table from the summary data
        const tableData = Object.entries(data).map(([key, value]) => [key, value]);
        
        // --- THIS IS THE FIX ---
        // Call autoTable as a function, passing the pdf instance to it
        autoTable(pdf, {
            startY: 35,
            head: [['Metric', 'Value']],
            body: tableData,
            theme: 'grid',
        });

        // Capture the chart as an image and add it to the PDF
        if (chartRef && chartRef.current) {
            try {
                const canvas = await html2canvas(chartRef.current, { backgroundColor: null });
                const imgData = canvas.toDataURL('image/png');
                
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                
                // Get the y-coordinate of the bottom of the table
                const lastTableY = (pdf).lastAutoTable.finalY || 50;
                pdf.addImage(imgData, 'PNG', 14, lastTableY + 15, pdfWidth - 28, pdfHeight);

            } catch (error) {
                console.error("Error capturing chart for PDF:", error);
            }
        }

        pdf.save("farm_summary.pdf");
        setIsGenerating(false);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md m-4">
                <h2 className="text-2xl font-bold mb-6">Export Summary</h2>
                <div className="space-y-4">
                    <button onClick={handleExportCSV} className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Download as CSV</button>
                    <button onClick={handleExportPDF} disabled={isGenerating} className="w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-green-300">
                        {isGenerating ? 'Generating PDF...' : 'Download as PDF'}
                    </button>
                    <div className="border-t pt-4">
                        <label className="block text-sm font-medium text-gray-700">Send as Email</label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter email address" className="mt-1 w-full p-2 border rounded" />
                        <button onClick={() => alert("Email functionality coming soon!")} className="mt-2 w-full px-4 py-2 bg-gray-400 text-white rounded-md cursor-not-allowed" title="Email functionality requires a server">Send Email (coming soon)</button>
                    </div>
                </div>
                <div className="mt-8 flex justify-end">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md">Close</button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal;